import { render, staticRenderFns } from "./UplodeDocumentsStatusDialog.vue?vue&type=template&id=2fb1384c&scoped=true"
import script from "./UplodeDocumentsStatusDialog.vue?vue&type=script&lang=ts"
export * from "./UplodeDocumentsStatusDialog.vue?vue&type=script&lang=ts"
import style0 from "./UplodeDocumentsStatusDialog.vue?vue&type=style&index=0&id=2fb1384c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb1384c",
  null
  
)

export default component.exports